import { useSelector} from "react-redux";

/**
 * @type import('src/types/state').TypedUseSelectorHook
 * 
 */
const useTypedSelector = (expr, shallow) => {
    return useSelector(expr, shallow );
}

export default useTypedSelector;